<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-13 08:58:58
 * @LastEditTime: 2021-03-04 15:44:05
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="$t('lang.devicesManagement.AddDevice')"
      :visible.sync="dialogVisible"
      width="60%"
      center
    >
      <div class="group-form">
        <!-- 项目选择表单组件 -->
        <project-select
          ref="projectSelect"
          :deviceItem="deviceItem"
          :inline="true"
        ></project-select>
      </div>
      <div>
        <!-- 设备选择表格组件 -->
        <select-deviceList ref="selectDevices"></select-deviceList>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">{{
          $t("lang.Button.cancel")
        }}</el-button>
        <el-button type="primary" size="mini" @click="subimtAdd">{{
          $t("lang.Button.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import selectDeviceList from "../../../components/selectDeviceList/index";
import projectSelect from "../../../components/projectSelect";
import { addDevice } from "@/api/cloudMonitor/deviceList";
export default {
  components: {
    selectDeviceList,
    projectSelect,
  },
  data() {
    return {
      deviceList: [],
      dialogVisible: false,
      active: 0,
      deviceGid: "", // 设备所属分组Id
      deviceItem: {}, //项目路由跳转查看详情后点击添加自动选择当前项目分组
    };
  },
  methods: {
    show(deviceGroup) {
      this.dialogVisible = true;
      this.active = 0;
      this.$nextTick(() => {
        this.$refs.projectSelect.clearData();
        if (deviceGroup && deviceGroup.groupId) {
          this.deviceItem = deviceGroup;
        }
      });
    },
    // 点击确认选择分组
    submitProject() {
      let checkResult = this.$refs.projectSelect.checkForm();
      if (checkResult === true) {
        this.active = this.active + 1;
      }
    },
    subimtAdd() {
      // 从选择设备公共组件中获取选择数据
      let selectDevices = this.$refs.selectDevices.getSelectDevices();
      let grouFormData = this.$refs.projectSelect.getFormData();
      // 向后端传最后一级项目分组Id即可
      if (grouFormData.groupTwo.groupId) {
        this.deviceGid = grouFormData.groupTwo.groupId;
      } else if (grouFormData.groupOne.groupId) {
        this.deviceGid = grouFormData.groupOne.groupId;
      }
      let checkResult = this.$refs.projectSelect.checkForm();
      if (checkResult !== true && selectDevices.length <= 0) {
        this.active = this.active + 1;
        this.$message.warning(
          this.$t("lang.devicesManagement.Noprojectgroups")
        );
      } else if (selectDevices.length <= 0) {
        this.$message.warning(
          this.$t("lang.devicesManagement.Nodeviceselected")
        );
      } else if (checkResult !== true) {
        this.$message.warning(this.$t("lang.devicesManagement.Noprojectgroup"));
      } else {
        let deviceIds = selectDevices.map((item) => {
          return item.deviceId;
        });
        let params = {
          deviceIds,
          deviceGid: this.deviceGid,
        };
        addDevice(params)
          .then((res) => {
            if (res.data.code === 0) {
              this.$message.success(
                this.$t("lang.devicesManagement.Addedsuccessfully")
              );
              this.$emit("updateList");
              this.dialogVisible = false;
            } else {
              this.$message.error(this.$t("lang.alarmNotice.msg9"));
            }
          })
          .catch(() => {});
      }
    },
  },
};
</script>
<style scoped></style>
